import { NgModule } from '@angular/core';
import { Router } from '@angular/router'; // splitbutton needs this
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
//import { FullCalendarModule } from 'primeng/fullcalendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextarea } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
//import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
//import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ChartModule } from 'primeng/chart';
import { BadgeModule } from 'primeng/badge';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DataViewModule } from 'primeng/dataview';
import { ToastModule } from 'primeng/toast';
import { SplitterModule } from 'primeng/splitter';
import { DatePickerModule } from 'primeng/datepicker';
import { PopoverModule } from 'primeng/popover';
import { DrawerModule } from 'primeng/drawer';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { DividerModule } from 'primeng/divider';
import { MenubarModule } from 'primeng/menubar';
import { IftaLabelModule } from 'primeng/iftalabel';
import { TextareaModule } from 'primeng/textarea';
@NgModule({
    imports: [
        DataViewModule,
        TextareaModule,
        IftaLabelModule,
        MenubarModule,
        TabsModule,
        SelectModule,
        FloatLabelModule,
        DrawerModule,
        PopoverModule,
        ProgressSpinnerModule,
        InputTextModule,
        CalendarModule,
        DatePickerModule,
        PanelModule,
        RadioButtonModule,
        DialogModule,
        SplitButtonModule,
        ToggleButtonModule,
        ButtonModule,
        CardModule,
        AccordionModule,
        InputSwitchModule,
        DropdownModule,
        InputTextarea,
        FieldsetModule,
        TableModule,
        PasswordModule,
        DynamicDialogModule,
        ToolbarModule,
        MultiSelectModule,
        //TabViewModule,
        SidebarModule,
        TreeModule,
        TreeTableModule,
        CalendarModule,
        DatePickerModule,
        MessagesModule,
        CheckboxModule,
        ConfirmDialogModule,
        //FullCalendarModule,
        ScrollPanelModule,
        MessageModule,
        MessagesModule,
        FileUploadModule,
        AutoCompleteModule,
        ColorPickerModule,
        //TriStateCheckboxModule,
        TooltipModule,
        MenuModule,
        ChartModule,
        BadgeModule,
        SelectButtonModule,
        ToastModule,
        SplitterModule,
        PasswordModule,
        DividerModule
    ],
    exports: [
        DataViewModule,
        TextareaModule,
        IftaLabelModule,
        MenubarModule,
        TabsModule,
        SelectModule,
        FloatLabelModule,
        DrawerModule,
        PopoverModule,
        ProgressSpinnerModule,
        InputTextModule,
        CalendarModule,
        DatePickerModule,
        PanelModule,
        RadioButtonModule,
        DialogModule,
        SplitButtonModule,
        ToggleButtonModule,
        ButtonModule,
        CardModule,
        AccordionModule,
        InputSwitchModule,
        DropdownModule,
        InputTextarea,
        CheckboxModule,
        FieldsetModule,
        TableModule,
        PasswordModule,
        DynamicDialogModule,
        ToolbarModule,
        MultiSelectModule,
        //TabViewModule,
        SidebarModule,
        TreeModule,
        TreeTableModule,
        CalendarModule,
        DatePickerModule,
        MessagesModule,
        ConfirmDialogModule,
        //FullCalendarModule,
        ScrollPanelModule,
        MessageModule,
        MessagesModule,
        FileUploadModule,
        AutoCompleteModule,
        ColorPickerModule,
        //TriStateCheckboxModule,
        TooltipModule,
        MenuModule,
        ChartModule,
        BadgeModule,
        SelectButtonModule,
        ToastModule,
        SplitterModule,
        PasswordModule,
        DividerModule
    ],
    providers: [
        { provide: Router, useValue: {} },
        ConfirmationService
    ]
})
export class EfaactPrimeNGModule {}

export * from 'primeng/accordion';
export * from 'primeng/api';
export * from 'primeng/autocomplete';
export * from 'primeng/button';
export * from 'primeng/calendar';
export * from 'primeng/card';
export * from 'primeng/checkbox';
export * from 'primeng/colorpicker';
export * from 'primeng/confirmdialog';
export * from 'primeng/dialog';
export * from 'primeng/dropdown';
export * from 'primeng/dynamicdialog';
export * from 'primeng/fieldset';
export * from 'primeng/fileupload';
//export * from 'primeng/fullcalendar';
export * from 'primeng/inputswitch';
export * from 'primeng/inputtext';
export * from 'primeng/inputtextarea';
export * from 'primeng/menu';
export * from 'primeng/message';
export * from 'primeng/messages';
export * from 'primeng/multiselect';
//export * from 'primeng/overlaypanel';
export * from 'primeng/panel';
export * from 'primeng/password';
export * from 'primeng/radiobutton';
export * from 'primeng/scrollpanel';
export * from 'primeng/sidebar';
export * from 'primeng/splitbutton';
export * from 'primeng/table';
export * from 'primeng/togglebutton';
export * from 'primeng/toolbar';
export * from 'primeng/tooltip';
export * from 'primeng/tree';
export * from 'primeng/treetable';
export * from 'primeng/utils';
export * from 'primeng/menu';
export * from 'primeng/chart';
export * from 'primeng/badge';
export * from 'primeng/selectbutton';
export * from 'primeng/dataview';
export * from 'primeng/toast';
export * from 'primeng/splitter';
export * from 'primeng/popover';
export * from 'primeng/floatlabel';
export { SelectModule } from 'primeng/select';
export { Select } from 'primeng/select';
export { DrawerModule } from 'primeng/drawer';
export { ButtonProps as ButtonProps } from 'primeng/button';
export { ButtonProps as SplitButtonProps } from 'primeng/splitbutton';
export * from 'primeng/tabs';
export * from 'primeng/password';
export * from 'primeng/divider';
export * from 'primeng/menubar';
export * from 'primeng/iftalabel';
// Explicitly re-export to resolve ambiguity with 'primeng/inputtextarea'
export {
    Textarea as TextareaComponent,
    TextareaClasses as TextareaComponentClasses,
    TextareaStyle as TextareaComponentStyle
} from 'primeng/textarea';
